/* Prestige owns scrolling, dragging and arrow navigation. This wrapper only
   detects overflow and manages controls when grids/editor sections resize. */
(() => {
  if (customElements.get('izy-option-carousel')) return;
  class OptionsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('scroll-carousel');
      if (!this.track) return;
      this.abort = new AbortController();
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.media = matchMedia('(min-width: 700px)');
      this.media.addEventListener('change', this.schedule, { signal: this.abort.signal });
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      for (const child of this.track.children) this.observer.observe(child);
      this.track.addEventListener('scroll', this.schedule, { passive: true, signal: this.abort.signal });
      customElements.whenDefined('scroll-carousel').then(() => {
        if (this.isConnected) this.schedule();
      });
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    update() {
      const desktop = this.dataset.desktopLayout || 'carousel';
      const mobile = this.dataset.mobileLayout;
      const layout = this.media.matches || !mobile || mobile === 'inherit' ? desktop : mobile;
      const wraps = layout === 'wrap';
      this.classList.toggle('is-wrapped', wraps);
      if (wraps && this.track.scrollLeft) this.track.scrollLeft = 0;
      const cells = [...this.track.children].filter(cell => !cell.hidden);
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const needed = cells.reduce((sum, cell) => sum + cell.getBoundingClientRect().width, 0)
        + gap * Math.max(0, cells.length - 1);
      // Reserved slots never change the track width when controls appear, so
      // compare against the actual track. Other carousels keep the full-wrapper
      // measurement to avoid resize feedback when their arrow slots collapse.
      const available = this.hasAttribute('data-reserve-controls') ? this.track.clientWidth : this.clientWidth;
      const overflow = !wraps && available > 0 && needed > available + 1;
      this.classList.toggle('has-overflow', overflow);
      const controls = this.querySelectorAll('carousel-prev-button, carousel-next-button');
      controls.forEach(control => { control.hidden = !overflow; });
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = Math.abs(this.track.scrollLeft);
      controls[0].firstElementChild.disabled = !overflow || left <= 1;
      controls[1].firstElementChild.disabled = !overflow || left >= max - 1;
    }
  }
  customElements.define('izy-option-carousel', OptionsCarousel);
})();
